let sentryInitialized = false;

export async function initSentry() {
  if (sentryInitialized) return;
  sentryInitialized = true;

  const Sentry = await import('@sentry/react');
  Sentry.init({
    dsn: 'https://20b75449bebf04b1c1c35702cef0fcbb@o4511141357092864.ingest.de.sentry.io/4511141365547088',
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
  });
}
